import axios from "axios";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { SO_API } from "../CreateSalesOrder/data";
import { ginesysSyncTone } from "../CreateSalesOrder/soUi";

export const lsSoSyncLogFilterValStr = "sales_order_sync_log_filter_obj";

export const soSyncLogEventTone = {
	QUEUED: { color: "#1565c0", bgcolor: "#e3f2fd" },
	SUCCESS: { color: "#2e7d32", bgcolor: "#e8f5e9" },
	FAILED: { color: "#b71c1c", bgcolor: "#ffebee" },
	SKIPPED: { color: "#5f6368", bgcolor: "#eef0f2" },
};

export const soSyncLogEventOptions = Object.keys(soSyncLogEventTone).map((key) => ({ key, name: key }));
export const ginesysSyncOptions = Object.keys(ginesysSyncTone).map((key) => ({ key, name: key }));

const enterColumn = (name, key, dataType = datatypes.STRING.key) => ({
	name,
	key,
	input_type: inputTypes.ENTER.key,
	data_type: dataType,
	editable: true,
	constraints: { DISPLAY: true },
});

const selectColumn = (name, key, list) => ({
	name,
	key,
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	editable: true,
	constraints: { DISPLAY: true },
	[selectOptionsKeyName]: { type: arrType, list },
});

export const soSyncLogColumnsObj = {
	id: enterColumn("ID", "id", datatypes.NUMBER.key),
	sales_order_id: enterColumn("SO ID", "sales_order_id", datatypes.NUMBER.key),
	so_number: enterColumn("SO Number", "so_number"),
	event_type: selectColumn("Event", "event_type", soSyncLogEventOptions),
	ginesys_sync: selectColumn("Ginesys Sync", "ginesys_sync", ginesysSyncOptions),
	ginesys_order_code: enterColumn("Ginesys ORDCODE", "ginesys_order_code", datatypes.NUMBER.key),
	triggered_by: enterColumn("Triggered By", "triggered_by"),
	error_message: enterColumn("Error", "error_message"),
	created_at: enterColumn("Created At", "created_at", datatypes.DATE.key),
};

export const soSyncLogTableColumns = [
	soSyncLogColumnsObj.id,
	soSyncLogColumnsObj.created_at,
	soSyncLogColumnsObj.so_number,
	soSyncLogColumnsObj.sales_order_id,
	soSyncLogColumnsObj.event_type,
	soSyncLogColumnsObj.ginesys_sync,
	soSyncLogColumnsObj.ginesys_order_code,
	soSyncLogColumnsObj.triggered_by,
	soSyncLogColumnsObj.error_message,
].map((col) => ({
	...col,
	align: "center",
	headerAlign: "center",
	minWidth: col.key === "so_number" || col.key === "error_message" || col.key === "triggered_by" ? 160 : 110,
}));

export const getSoSyncLogFilterColumns = () => [
	soSyncLogColumnsObj.so_number,
	soSyncLogColumnsObj.sales_order_id,
	soSyncLogColumnsObj.event_type,
	soSyncLogColumnsObj.ginesys_sync,
	soSyncLogColumnsObj.triggered_by,
];

export const listSalesOrderSyncLogsApi = async ({ limit, offset, filter }) => {
	const res = await axios.post(`${SO_API}/sync-logs`, { limit, offset, filter });
	return res.data?.result || { rows: [], total_rows_count: 0 };
};
